import { computed, defineComponent, ref, watch } from 'vue';
import { Button, WidgetInput } from '@yellowcard/components-library-vue3';
import LoaderComponent from '@/components/general/LoaderComponent.vue';
import TransactHeader from '@/components/transact/TransactHeader.vue';
import { numberFormat, isValidEmail } from '@/utils/helpers';
import useTransactionsStore from '@/store/modules/transactions';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
import { AuthTypes } from '@/types/auth';
import { TransactTypes } from '@/types/transact';
import router from '@/router';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
import en from '@/locale/en.locale';
export default defineComponent({
    name: 'EmailInput',
    components: {
        Button,
        WidgetInput,
        LoaderComponent,
        TransactHeader,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const { loadingMessage, currentStep: buyCurrentStep } = storeToRefs(transactionsStore);
        const authStore = useAuthStore();
        const { currentStep, email, standaloneAuthFlow, userNotRegistered, partnerId, } = storeToRefs(authStore);
        const error = ref(undefined);
        const rules = computed(() => ({
            email: (value) => isValidEmail(value) ? true : 'Please enter a valid email address',
        }));
        const buttonDisabled = ref(true);
        const loading = ref(false);
        const emailError = ref('');
        buttonDisabled.value = rules.value.email(email.value) !== true;
        watch(email, newInput => {
            buttonDisabled.value = rules.value.email(newInput) !== true;
            userNotRegistered.value = false;
        });
        const signIn = async () => {
            error.value = undefined;
            loading.value = true;
            loadingMessage.value = 'Sending you a secure OTP via email';
            buttonDisabled.value = true;
            try {
                await authStore.SignIn({
                    email: email.value,
                });
                loading.value = false;
                loadingMessage.value = '';
                currentStep.value = AuthTypes.AuthSteps.AUTH_2;
            }
            catch (e) {
                if (e.message.includes('User does not exist')) {
                    userNotRegistered.value = true;
                    loading.value = false;
                    loadingMessage.value = '';
                    buttonDisabled.value = false;
                }
                else if (e.message.includes('user is blocked')) {
                    loading.value = false;
                    loadingMessage.value = '';
                    currentStep.value = AuthTypes.AuthSteps.BLOCKED;
                }
                else {
                    error.value = e.message;
                    loading.value = false;
                    loadingMessage.value = '';
                }
            }
        };
        const signUp = async () => {
            try {
                error.value = undefined;
                loading.value = true;
                loadingMessage.value = 'Signing up';
                buttonDisabled.value = true;
                await authStore.SignUp({
                    email: email.value,
                });
                await signIn();
            }
            catch (e) {
                error.value = e.message;
                loading.value = false;
                loadingMessage.value = '';
            }
        };
        const viewPrivacyPolicy = (evt) => {
            evt.stopImmediatePropagation();
            window.open(en.home.menu.privacyLink, '_blank');
        };
        const viewTermsOfUse = (evt) => {
            evt.stopImmediatePropagation();
            window.open(en.home.menu.tosLink, '_blank');
        };
        const clickContinue = async () => {
            trackEvent(MIXPANEL_EVENTS.SIGNIN.EMAIL, {
                partner: partnerId.value,
            });
            if (userNotRegistered.value) {
                await signUp();
            }
            else {
                await signIn();
            }
        };
        const goBack = () => {
            router.push('/transact');
            if (standaloneAuthFlow.value) {
                standaloneAuthFlow.value = false;
                return;
            }
            buyCurrentStep.value = TransactTypes.TransactSteps.BUY_3;
        };
        const onKeyPress = () => {
            console.log('');
        };
        return {
            emailError,
            numberFormat,
            email,
            buttonDisabled,
            clickContinue,
            signIn,
            signUp,
            rules,
            loading,
            error,
            userNotRegistered,
            goBack,
            standaloneAuthFlow,
            viewPrivacyPolicy,
            onKeyPress,
            viewTermsOfUse,
        };
    },
});
